import {
  Color,
  FontSize,
  FontWeight,
  colors,
  getFontStyle,
  getHeight,
} from '@cabonline/ui-shared';
import styled from '@emotion/styled';
import { Link, LinkProps } from 'react-router-dom';

type CustomStyles = {
  weight?: FontWeight;
  size?: FontSize;
  color?: Color;
};

export type LinkRouterProps = LinkProps & CustomStyles;

export const LinkRouter = styled(Link)<CustomStyles>`
  line-height: ${getHeight('m')};
  margin: 0;
  padding: 0;
  ${({ size, weight }) => getFontStyle(size, weight)}
  color: ${({ color }) => (color ? color : colors.black)};
  display: inline-block;
  height: ${getHeight('m')};
  background: none;
  border: none;
  &:focus {
    outline: 2px solid ${colors.black};
  }
`;
